import { nonUndefined } from "Utility";

export const mapMultiple = <TFsModel, TModel>(
  fsModels: TFsModel[] | undefined,
  mapSingle: (fsModel: TFsModel) => TModel | undefined
): TModel[] | undefined => {
  if (!fsModels) {
    return undefined;
  }

  return nonUndefined(fsModels.map(mapSingle));
};
